export default function onScroll() {

	let headerSticked = false;
	let height = window.innerHeight;
	let scrollY = window.scrollY;
	let header = document.querySelector('.cd-header');
	const headerTop = document.getElementById('sec2').getBoundingClientRect().top + scrollY;

	let ls = 0;
	document.addEventListener('scroll', onScroll);

	// Revealed elements
	let elements1 = Array.from(document.querySelectorAll('.sec2__services .fadeInFromTop')),
		years = Array.from(document.querySelectorAll('.vertical-scroll--block .item__header.fromBottom')),
		yearsContent = Array.from(document.querySelectorAll('.vertical-scroll--block .item__event.fromLeft')),
		news = Array.from(document.querySelectorAll('.news__block .news__item.fromBottom'));

	// addDelay to multiple items
	addDelay(yearsContent);
	addDelay(elements1);
	addDelay(news);

	// Parallax effect and it is top and bottom
	let parallaxBg1 = document.querySelector('.sec2 .section__clip');
	let parallaxBg2 = document.querySelector('.sec5');
	let parallaxBg3 = document.querySelector('.sec6 .container');
	let parallaxBg4 = document.querySelector('.sec7 .sec7__parallax');

	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let notScrolled = true;
	onScroll();

	// callback trigger on every scroll
	function onScroll() {
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		revealElements(elements1);

		years.forEach((x) => {
			reveal(x, height * 0.75);
		})

		revealElements(yearsContent, height * 0.7);
		revealElements(news, height * 0.6);
		reveal(document.querySelector('.news__action .button'), height * 0.6)

		if(notScrolled || inView(document.querySelector('.sec1'))) {
			headerChangeBg();
		}
			parallaxBgPos(scrollTop, parallaxBg1, notScrolled, 0, 40);

			parallaxBgPos(scrollTop, parallaxBg2, notScrolled, 60, 90);

			parallaxBgPos(scrollTop, parallaxBg3, notScrolled, 0, 100);

			parallaxBgPos(scrollTop, parallaxBg4, notScrolled, 10, 0, 'translateY');

		notScrolled = false;
	}


	function inView(section) {
		let top = section.getBoundingClientRect().top,
				bottom = section.nextElementSibling.getBoundingClientRect().bottom;
		if(scrollTop >= top && scrollTop <= bottom) {
			return true;
		} else {
			return false;
		}
	}



	function parallaxBgPos(st, el, notScrolled, start, end, property) {
		let { top, bottom } = el.getBoundingClientRect();
		let t = top + st - height,
				b = bottom + st;

		if(notScrolled || (st > t && st < b)) {
			let x = start + ((end - start) * ((st - t) / (b - t)));
			if(!property) {
				el.style.backgroundPosition = '100% ' + x + '%';
			} else if(property === 'translateY') {
				el.style.transform = 'translateY(' + x + '%)';
			}
		}

	}

	function reveal(el, offset = 0) {
		let scrolled = window.pageYOffset || document.documentElement.scrollTop;

		if(scrolled > el.getBoundingClientRect().top + scrolled - offset) {
			if(!el.classList.contains('animate')) {
				el.classList.add('animate');
			}
		}
	}

	function revealElements(arr, offset = 300) {
		let scrolled = window.pageYOffset || document.documentElement.scrollTop;

		if(scrolled > arr[0].getBoundingClientRect().top + scrolled - offset) {
			arr.forEach((x, i) => {
				if(!x.classList.contains('animate')) {
					x.classList.add('animate');
				}
			})

		}

	}

	function getDirection(st) {
		if(st > ls) {
			ls = st;
			return -1;
		} else if( st < ls ) {
			ls = st;
			return 1;
		}


	}

	function addDelay(arr) {
		arr.forEach((x, i) => {
			x.style.transitionDelay = i * 200 + 'ms';
		})
	}

	function headerChangeBg() {
		let y = window.scrollY;
		if(!headerSticked && y >= (headerTop - 65)) {
			header.classList.add('stick');
			headerSticked = true;
		} else if(headerSticked && y < (headerTop - 65)) {
			header.classList.remove('stick');
			headerSticked = false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/onScroll.js